import { EditOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  TimePicker,
  Tooltip
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CustomDatePicker from '../../components/CustomDatePicker';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { TIPOS_JOB } from '../../constants';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 }
  }
};

const JovView = (props) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState();
  const [activo, setActivo] = useState();

  useEffect(() => {
    const loadModel = async () => {
      try {
        const response = await instanceRef.instance.get(`/job/${id}`);
        if (response.data?.data) {
          const jobModel = response.data?.data;
          setModel({
            ...jobModel,
            inicio: moment(jobModel.inicio),
            fin: moment(jobModel.fin),
            hora_inicio: moment(jobModel.inicio, 'HH:mm:ss'),
            hora_fin: moment(jobModel.fin, 'HH:mm:ss')
          });
          setActivo(jobModel.activo);
        }
      } catch (error) {
        errorHandler(error);
      }
      setLoading(false);
    };
    if (id && form) {
      loadModel();
    }
  }, [id, form]);

  useEffect(() => {
    form.resetFields();
  }, [model, form]);

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Datos de la Tarea Programada"
        style={{ textAlign: 'left' }}
        extra={
          <Tooltip title="Editar Tarea Programada">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => props.history.push(`edit/${id}`)}
            />
          </Tooltip>
        }
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div style={{ maxWidth: '500px' }}>
            <Form
              {...formItemLayout}
              initialValues={model}
              scrollToFirstError
              form={form}
              name="job"
              autoComplete="off"
              layout="vertical"
            >
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={24} md={24} align="start">
                  <Form.Item label="Aseguradora" name="aseguradora" />
                </Col>
                <Col xs={24} md={24} align="start">
                  <Form.Item label="Tipo" name="tipo">
                    <Select
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      disabled
                    >
                      {TIPOS_JOB.map(({ codigo, descripcion }) => (
                        <Option key={codigo} value={codigo}>
                          {codigo} - {descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={24} md={24} align="start">
                  <Form.Item label="Descripción" name="descripcion">
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item label="Activo">
                <Radio.Group values={activo} disabled>
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>

              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={12} md={12} align="start">
                  <Form.Item label="Fecha Inicio" name="inicio">
                    <CustomDatePicker
                      style={{ width: '100%' }}
                      placeholder="DD/MM/YYYY"
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} align="start">
                  <Form.Item label="Hora Inicio" name="hora_inicio">
                    <TimePicker style={{ width: '100%' }} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={12} md={12} align="start">
                  <Form.Item label="Fecha Fin" name="fin">
                    <CustomDatePicker
                      style={{ width: '100%' }}
                      placeholder="DD/MM/YYYY"
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} align="start">
                  <Form.Item label="Hora Fin" name="hora_fin">
                    <TimePicker style={{ width: '100%' }} disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default JovView;
